import {
  AverageResponseTimes,
  AverageResponseTimesRaw,
  FeedbackPreferences,
  FeedbackPreferencesRaw,
  WorkHours,
  WorkHoursRaw,
  WorkStylePreferences,
  WorkStylePreferencesRaw,
  WorkStylePreferencesValues,
  WorkStylePreferencesValuesRaw,
} from '../../interfaces/work-style-preferences';

export const sanitizeWorkStylePreferencesValuesFromRaw = (
  data: WorkStylePreferencesValuesRaw
): WorkStylePreferencesValues => {
  return {
    averageResponseTimes: data.average_response_times,
    feedbackCadence: data.feedback_cadence,
    oneOnOneCadence: data.one_on_one_cadence,
    workPlace: data.work_place,
  };
};

export const sanitizeWorkStylePreferencesToRaw = (
  data: WorkStylePreferences
): WorkStylePreferencesRaw => {
  return {
    average_response_times: sanitizeAverageResponseTimesToRaw(
      data.averageResponseTimes
    ),
    feedback_preferences: sanitizeFeedbackPreferencesToRaw(
      data.feedbackPreferences
    ),
    one_on_one_cadence: data.oneOnOneCadence,
    work_hours: sanitizeWorkHoursToRaw(data.workHours),
    work_place: data.workPlace,
  };
};

export const sanitizeWorkStylePreferencesFromRaw = (
  data: WorkStylePreferencesRaw
): WorkStylePreferences | null => {
  if (!data) return null;

  return {
    averageResponseTimes: sanitizeAverageResponseTimesFromRaw(
      data.average_response_times
    ),
    feedbackPreferences: sanitizeFeedbackPreferencesFromRaw(
      data.feedback_preferences
    ),
    oneOnOneCadence: data.one_on_one_cadence,
    workHours: sanitizeWorkHoursFromRaw(data.work_hours),
    workPlace: data.work_place,
  };
};

export const sanitizeAverageResponseTimesFromRaw = (
  data: AverageResponseTimesRaw
): AverageResponseTimes | null => {
  if (!data) return null;

  return {
    chat: data.chat,
    email: data.email,
    phone: data.phone,
    textMessage: data.text_message,
  };
};

export const sanitizeAverageResponseTimesToRaw = (
  data: AverageResponseTimes | null
): AverageResponseTimesRaw => {
  if (!data) {
    return {};
  }

  return {
    chat: data.chat,
    email: data.email,
    phone: data.phone,
    text_message: data.textMessage,
  };
};

export const sanitizeFeedbackPreferencesFromRaw = (
  data: FeedbackPreferencesRaw
): FeedbackPreferences | null => {
  if (!data) return null;

  return {
    cadence: data.cadence,
    deliveryMethod: data.delivery_method,
  };
};

export const sanitizeFeedbackPreferencesToRaw = (
  data?: FeedbackPreferences | null
): FeedbackPreferencesRaw => {
  if (!data) {
    return {};
  }

  return {
    cadence: data.cadence,
    delivery_method: data.deliveryMethod,
  };
};

export const sanitizeWorkHoursFromRaw = (
  data: WorkHoursRaw | undefined
): WorkHours | undefined => {
  if (!data) return undefined;

  return {
    startTime: data.start_time,
    endTime: data.end_time,
  };
};

export const sanitizeWorkHoursToRaw = (
  data: WorkHours | undefined
): WorkHoursRaw | undefined => {
  if (!data) return undefined;

  return {
    end_time: data.endTime || null,
    start_time: data.startTime || null,
  };
};
